import { Gameboard } from "../models/Gameboard.js";
import { AppState } from "../state/AppState.js";

const Player = new Gameboard("Player");
const Computer = new Gameboard("Computer");

AppState.initialize(Player, Computer);

Player.randomizeShipPlacement();
Computer.randomizeShipPlacement();

export { Player, Computer };
